import { Typography } from "@mui/material"
import { NewsCreatorRoles } from "../../../News/model"
import type { FormattedNews } from "./News"

const roleToLabel: {
  [NewsCreatorRoles.UPP_PRESIDENT]: string
  [NewsCreatorRoles.UPP_REPRESENTATIVE]: string
} = {
  [NewsCreatorRoles.UPP_PRESIDENT]: "Président UPP",
  [NewsCreatorRoles.UPP_REPRESENTATIVE]: "Représentant CD",
}

export const NewsCreatorRole = (news: FormattedNews) => {
  if (
    news.creatorRole === NewsCreatorRoles.UPP_PRESIDENT ||
    news.creatorRole === NewsCreatorRoles.UPP_REPRESENTATIVE
  ) {
    return (
      <>
        ,{" "}
        <Typography color="primary.main" fontWeight={500} component="span">
          {roleToLabel[news.creatorRole]}
        </Typography>
      </>
    )
  }

  return null
}
